export const previewOptions = [
  {
    key: 0,
    label: "common:use_toddle_default_login_page",
  },
  {
    key: 1,
    label: "common:use_custom_school_login_page",
  },
];

export const tabOptions = [
  {
    value: "web",
    label: "common:web",
  },
  {
    value: "tablet",
    label: "common:tablet",
  },
  {
    value: "mobile",
    label: "common:mobile",
  },
];

export const appOptions = [
  {
    key: "staff",
    label: "common:teacher_app",
  },
  {
    key: "student",
    label: "common:student_app",
  },
  {
    key: "parent",
    label: "common:family_app",
  },
];

export const webOptions = [
  {
    key: "staff",
    label: "Teacher Account",
    orgLabel: "Sign in to your teacher account",
  },
  {
    key: "student",
    label: "Student Account",
    orgLabel: "Sign in to your student account",
  },
  {
    key: "parent",
    label: "Family Account",
    orgLabel: "Sign in to your family account",
  },
];

export const LOGIN_OPTION_TYPES = {
  IDP_CONFIG: "IDP_CONFIG",
  OAUTH_IDP_CRED: "OAUTH_IDP_CRED",
  SSO: "SSO",
  OAUTH_SP_CRED: "OAUTH_SP_CRED",
  EMAIL_OTP_LOGIN: "EMAIL_OTP_LOGIN",
  PASSWORD_LOGIN: "PASSWORD_LOGIN",
  STUDENT_SIGNIN_CODE: "STUDENT_SIGNIN_CODE",
  SMS_OTP_LOGIN: "SMS_OTP_LOGIN",
  CREATE_PARENT_ACCOUNT: "CREATE_PARENT_ACCOUNT",
};

export const USER_TYPES = {
  student: "student",
  staff: "staff",
  parent: "parent",
};

export const TAB_TYPES = {
  web: "web",
  mobile: "mobile",
  tablet: "tablet",
};

export const getAppColor = app => {
  switch (app) {
    case USER_TYPES.parent:
      return "#6464dc";
    case USER_TYPES.student:
      return "#2dadba";
    case USER_TYPES.staff:
      return "var(--red-600)";
    default:
      return "var(--red-600)";
  }
};

export const validateNoSpaces = value => {
  return /^[a-zA-Z0-9_-]{1,12}$/.test(value);
};
